import React from 'react';
import EntrepriseDashboard from './EntrepriseDashboard';

const AdminDashboard = () => {
    return <EntrepriseDashboard />;
};

export default AdminDashboard;
